import SidebarContext from '@/contexts/sidebar.context'
import { useContext } from 'react'

function useSidebar() {
  const context = useContext(SidebarContext)
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider.')
  }

  return context
}

export default useSidebar
